import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getDeployment } from '@/redux/modules/config';
import { getRelatedSearches } from './relatedSearches.api';
import { MAX_RELATED_SEARCH_SUGGESTIONS, RelatedSearchItem } from './relatedSearches.types';

export const fetchRelatedSearchesForSearchPage = createAsyncThunk<RelatedSearchItem[], string>(
    'la/domain/relatedSearches/fetchRelatedSearchesForSearchPage',
    async (searchTerm, { getState }) => {
        const deployment = getDeployment(getState());
        if (!deployment) {
            return [];
        }

        const { relatedSearches } = await getRelatedSearches({ deployment, query: searchTerm });
        return (relatedSearches ?? []).slice(0, MAX_RELATED_SEARCH_SUGGESTIONS);
    }
);
